import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../../services/config';
import { FailedMessagesEndpoint } from '../../constants/failed-messages-endpoint';

@Injectable({
  providedIn: 'root',
})
export class Sc3FailedTransactionMessageService {
  constructor(private http: WrapperHttpService) {}

  getSc3FailedTransactionMessage(rawMessageId: string): Observable<string> {
    const url = `${API_URL}${FailedMessagesEndpoint.Base}${FailedMessagesEndpoint.Sc3}${FailedMessagesEndpoint.FailedTransaction}/${rawMessageId}${FailedMessagesEndpoint.Raw}`;
    return this.http.withLoading().get<string>(url, { responseType: 'text' });
  }
}
